import * as React from 'react';
import {  ButtonType, ButtonWidget, TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import { Messages } from '../../codegen/Localize';
import { Location } from '../../common/react/Location';
import { ServiceLocator } from '../../app/ServiceLocator';
import { appStore } from '../../app/AppStore';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';
import { ServerService } from '../../ts/services/ServerService';
import {
  errorMessageStyles,
  linkStyles,
  messageStyles,
  outterDivStyles,
  undoButtonStyles
} from '../styles/AddOrRemoveFromDataAlertStyles';

export const ERROR_MESSAGE_TEST_ID = 'error-message';
export const PRIMARY_MESSAGE_TEST_ID = 'message';
const LINK_TO_MY_ALERTS_TEST_ID = 'go-to-my-alerts';
const UNDO_ACTION_TEST_ID = 'undo-action';

type  AddOrRemoveDataAlertComponentProps = {
  errorOccurred: boolean;
  message: string;
  undoAction: () => Promise<void>;
  undoButtonText: string;
}

export function AddOrRemoveDataAlertComponent(props: AddOrRemoveDataAlertComponentProps): JSX.Element {
  return <div style={outterDivStyles}>
      {props.errorOccurred && <p data-tb-test-id={ERROR_MESSAGE_TEST_ID} style={errorMessageStyles}>
        { Messages.errorUhOh() }
      </p>}
      <p data-tb-test-id={PRIMARY_MESSAGE_TEST_ID} style={messageStyles}>
        { props.message }
      </p>
      <div style={linkStyles}>
        <TextLinkWidget
          href={getLinkToDataAlert()}
          kind={TextLinkKind.Standard}
          testId={LINK_TO_MY_ALERTS_TEST_ID}>
          { Messages.goToMyAlerts() }
        </TextLinkWidget>
      </div>
      {props.errorOccurred || <ButtonWidget
        buttonType={ButtonType.LowEmphasis}
        handleClick={async () => await props.undoAction().then(() => Location.instance.setUrl(getLinkToDataAlert()))}
        style={undoButtonStyles}
        testId={UNDO_ACTION_TEST_ID}>
        { props.undoButtonText }
      </ButtonWidget>}
    </div>;
}

function getLinkToDataAlert(): string {
  const currentUser = ServiceLocator.get<ServerService>('ServerService').sessionUserInfo();
  const siteUrls = siteUrlsSelector(appStore.getState());
  return siteUrls.userDataAlertsUrl(currentUser.username, currentUser.domainName);
}
